import script from "./AppSide.vue?vue&type=script&setup=true&lang=js"
export * from "./AppSide.vue?vue&type=script&setup=true&lang=js"

import "./AppSide.vue?vue&type=style&index=0&id=ee9ac638&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ee9ac638"]])

export default __exports__